import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, PageHeader, dt } from "./_shared";

export default function AdminAudit() {
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [action, setAction] = useState("");
  const [actor, setActor] = useState("");
  const [page, setPage] = useState(1);

  const load = () => {
    const p = new URLSearchParams({ page, page_size: 50 });
    if (action) p.set("action", action);
    if (actor) p.set("actor", actor);
    api.get(`/admin/audit?${p}`).then(r => { setRows(r.data.rows); setTotal(r.data.total); });
  };
  useEffect(() => { load(); }, [page]);

  return (
    <div className="p-3 sm:p-6 lg:p-8" data-testid="admin-audit">
      <PageHeader title="Auditoria" subtitle={`${total} eventos registrados`}/>
      <Card className="mb-6">
        <div className="flex flex-wrap gap-2">
          <input placeholder="Ação (ex: PLAN_CREATED)" value={action} onChange={e=>setAction(e.target.value)}
            className="flex-1 bg-[#0a0d17] border border-white/5 rounded-lg px-3 py-2 text-sm text-slate-200" data-testid="admin-audit-action"/>
          <input placeholder="Autor (e-mail)" value={actor} onChange={e=>setActor(e.target.value)}
            className="flex-1 bg-[#0a0d17] border border-white/5 rounded-lg px-3 py-2 text-sm text-slate-200" data-testid="admin-audit-actor"/>
          <button onClick={()=>{setPage(1); load();}}
            className="px-4 py-2 rounded-lg bg-[#d4a24c] text-black text-sm font-semibold" data-testid="admin-audit-filter">Filtrar</button>
        </div>
      </Card>
      <Card testid="admin-audit-list">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-[11px] uppercase tracking-wider text-slate-500 border-b border-white/5">
              <th className="py-3 pr-4">Quando</th>
              <th className="py-3 pr-4">Ação</th>
              <th className="py-3 pr-4">Autor</th>
              <th className="py-3 pr-4">Alvo</th>
              <th className="py-3 pr-4">IP</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan="5" className="py-8 text-center text-slate-500">Nenhum evento registrado</td></tr>}
            {rows.map((r, i) => (
              <tr key={i} className="border-b border-white/5" data-testid={`admin-audit-row-${i}`}>
                <td className="py-2 pr-4 text-slate-400 text-xs">{dt(r.created_at)}</td>
                <td className="py-2 pr-4"><span className="font-mono text-[#d4a24c] text-xs">{r.action}</span></td>
                <td className="py-2 pr-4 text-slate-300">{r.actor_email}</td>
                <td className="py-2 pr-4 text-slate-400 font-mono text-xs">{r.target || "—"}</td>
                <td className="py-2 pr-4 text-slate-500 text-xs">{r.ip || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
